import { render, staticRenderFns } from "./DeliveryStatus.vue?vue&type=template&id=fd5a2bcc&scoped=true&"
import script from "./DeliveryStatus.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatus.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStatus.vue?vue&type=style&index=0&id=fd5a2bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5a2bcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
